import HTree from './HTree.vue'

// 为组件提供 install 安装方法，供按需引入
HTree.install = function (Vue) {
    Vue.component(HTree.name, HTree)
}
  
// 默认导出组件
export default HTree